import { render, staticRenderFns } from "./ImportFiles.vue?vue&type=template&id=6ba15046&"
import script from "./ImportFiles.vue?vue&type=script&lang=js&"
export * from "./ImportFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba15046')) {
      api.createRecord('6ba15046', component.options)
    } else {
      api.reload('6ba15046', component.options)
    }
    module.hot.accept("./ImportFiles.vue?vue&type=template&id=6ba15046&", function () {
      api.rerender('6ba15046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/ImportFiles.vue"
export default component.exports